import { NodeType } from '../types';

import type { LeafNode, Node } from '../types';

export function isLeafNode(node: Node): node is LeafNode {
  return node.type === NodeType.leaf;
}
